import React from 'react';
import SbEditable from 'storyblok-react';

import badge from './badge.png';
import './energy-shield-badge.scss';

const EnergyShieldBadge = (props) => {
  return (
    <SbEditable content={props.blok}>
      <div className="energy-shield-badge">
        <div className="logo">
          <img src={badge} alt="EnergyShield"></img>
        </div>
        <div className="text">
          <h3>
            Swell Energy<em>Shield</em>
          </h3>
          <p>
            One easy add-on to your home energy system that provides total off-grid independence.
          </p>
        </div>
      </div>
    </SbEditable>
  );
};

export default EnergyShieldBadge;
